'use strict';
module.exports = errWithCauseSerializer;
var isErrorLike = require('./err-helpers').isErrorLike;
var _require = require('./err-proto'), pinoErrProto = _require.pinoErrProto, pinoErrorSymbols = _require.pinoErrorSymbols;
var seen = pinoErrorSymbols.seen;
var toString = Object.prototype.toString;
function errWithCauseSerializer(err) {
    if (!isErrorLike(err)) {
        return err;
    }
    err[seen] = undefined // tag to prevent re-looking at this
    ;
    var _err = Object.create(pinoErrProto);
    _err.type = toString.call(err.constructor) === '[object Function]' ? err.constructor.name : err.name;
    _err.message = err.message;
    _err.stack = err.stack;
    if (Array.isArray(err.errors)) {
        _err.aggregateErrors = err.errors.map(function(err) {
            return errWithCauseSerializer(err);
        });
    }
    if (isErrorLike(err.cause) && !Object.prototype.hasOwnProperty.call(err.cause, seen)) {
        _err.cause = errWithCauseSerializer(err.cause);
    }
    for(var key in err){
        if (_err[key] === undefined) {
            var val = err[key];
            if (isErrorLike(val)) {
                if (!Object.prototype.hasOwnProperty.call(val, seen)) {
                    _err[key] = errWithCauseSerializer(val);
                }
            } else {
                _err[key] = val;
            }
        }
    }
    delete err[seen] // clean up tag in case err is serialized again later
    ;
    _err.raw = err;
    return _err;
}
